export class DeviceKeyRegistrationError extends Error {
  constructor(message: string, public readonly cause?: unknown) {
    super(message);
    this.name = 'DeviceKeyRegistrationError';
  }
}

export async function ensureDeviceKeyRegistered(_profileId: number): Promise<void> {
  // No-op on web - device key registration is not supported
}

export function resetRegistrationState(_profileId?: number): void {
  // No-op on web
}

export async function forceReRegister(_profileId: number): Promise<void> {
  // No-op on web
}
